import React from 'react';
import { COLORS } from '~/src/styles/tokens/colors';
import type { ChildrenType } from '~/src/models/types/common.types';
import * as Styled from './nav-link.styles';

interface LinkProps {
    href: string;
    linkColor?: COLORS;
    children: ChildrenType;
    textDecoration?: string;
    onClick?: () => void;
    target?: string;
}

export const NavLink: React.FC<LinkProps> = ({ href, linkColor, children, textDecoration, onClick, target }) => {
    return (
        <Styled.Link
            href={href}
            linkcolor={linkColor}
            textDecoration={textDecoration}
            onClick={onClick}
            target={target || '_self'}
        >
            {children}
        </Styled.Link>
    );
};
